import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FilteredListConfig, Badge } from '@appcatalyst/ng-cms-core-lib';

@Component({
  selector: 'app-sources',
  templateUrl: './sources.component.html',
  styleUrls: ['./sources.component.scss']
})
export class SourcesComponent implements OnInit {
  private sources: any[]

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private config: FilteredListConfig
  ) { }

  ngOnInit() {
    this.route.data.subscribe((data: {sources: any}) => {
      this.sources = data.sources.data
      this.config.listItems = this.sources.map(source => {
        let badges: Badge[] = [
          {
            text: source.id,
            className: 'badge-info'
          }
        ]
        return {
          _id: source.id,
          title: source.name,
          description: source.ac_group,
          badge: badges
        }
      });
      this.config.count = data.sources.count
      this.config.page = data.sources.page
      this.config.limit = data.sources.limit
      this.config.emitChanges()
      this.config.rightButtonLabel = 'New Source'
      this.config.rightButtonAction = this.createSource  
    })
    this.config.title = 'Sources'
    this.config.listItemClicked = this.sourceSelected
  }

  sourceSelected = (id: string) => {
    this.router.navigate([id], { relativeTo: this.route })
  }

  createSource = (iid: number) => {
    this.router.navigate([ 'new' ], {relativeTo: this.route})
  }
}
